import { Extension } from '@/types/extension'
import { Settings } from '@/types/dashboard'

export function isMilliseconds (time: number) {
    return (time + '').length === 13
}

export function getInitialTime (time: number) {
    const milliseconds = isMilliseconds(time)
        ? time
        : time * 1000

    const initialTime = new Date().getTime() - milliseconds

    return initialTime > 0
        ? Math.floor(initialTime / 1000)
        : 0
}

const answeredCallStatuses = {
    hold: 'Hold',
    talking: 'Talking'
}

export function getInitialExtensionTime (extension: Extension, settings: Settings = {}) {
    const {
        resetIdleTime,
        resetStatusTimeOnCallUpdate,
    } = settings

    // Current call state
    const callStatus = extension.currentCall && extension.currentCall.callstatus

    // Agent is in an answered call (Talking or Hold)
    const isAnsweredCall =
        callStatus === answeredCallStatuses.hold ||
        callStatus === answeredCallStatuses.talking

    /**
     * SHORT-CIRCUIT
     * If status time should NOT reset on call updates
     * and the agent is already in an answered call,
     * always count time from when the call was answered.
     * (Hold / unhold must not reset status time)
     */
    if (!resetStatusTimeOnCallUpdate && isAnsweredCall) {
        return getInitialTime(extension.lastAnsweredCallEventEpoch_UTC_CLIENT)
    }

    // Base timestamps that can affect the timer
    const timestamps = [
        extension.representativeUpdated_UTC_CLIENT,       // status change
        extension.lastAnsweredCallEventEpoch_UTC_CLIENT, // call answered
    ]

    /**
     * Decide whether last call activity should influence the timer
     */
    const shouldIncludeLastCallEvent =
        !resetIdleTime ||
        (resetIdleTime && resetStatusTimeOnCallUpdate && isAnsweredCall)

    if (shouldIncludeLastCallEvent) {
        timestamps.push(extension.lastCallEventEpoch_UTC_CLIENT)
    }

    // Use the most recent relevant timestamp
    return getInitialTime(Math.max(...timestamps))
}
